import type {
	CoursesAdminActiveUsersQueryDto,
	CoursesAdminCourseAnalyticsQueryDto,
} from '@sportspredict/shared';
import type { Wire } from '../../types/common.types';
import { coursesApi } from './courses-base.api';
import type {
	GetPlatformAnalyticsOutput,
	GetCourseAnalyticsInput,
	GetCourseAnalyticsOutput,
	GetCourseModuleTagBreakdownInput,
	GetCourseModuleTagBreakdownOutput,
	GetActiveUsersInput,
	GetActiveUsersOutput,
} from '../../types/admin-analytics.types';

const TAG = 'courses:admin-analytics' as const;

export const adminAnalyticsEndpoints = coursesApi.injectEndpoints({
	endpoints: (builder) => ({
		getPlatformAnalytics: builder.query<GetPlatformAnalyticsOutput, void>({
			query: () => ({ url: 'courses/admin/platform/analytics' }),
			providesTags: [TAG],
		}),
		getCourseAnalytics: builder.query<GetCourseAnalyticsOutput, GetCourseAnalyticsInput>({
			query: (params) => ({
				url: 'courses/admin/platform/analytics/course',
				params: params satisfies Wire<CoursesAdminCourseAnalyticsQueryDto>,
			}),
			providesTags: [TAG],
		}),
		getCourseModuleTagBreakdown: builder.query<
			GetCourseModuleTagBreakdownOutput,
			GetCourseModuleTagBreakdownInput
		>({
			query: (params) => ({
				url: 'courses/admin/platform/analytics/course-module-tags',
				params: params satisfies Wire<CoursesAdminCourseAnalyticsQueryDto>,
			}),
			providesTags: [TAG],
		}),
		getActiveUsers: builder.query<GetActiveUsersOutput, GetActiveUsersInput>({
			query: (params) => ({
				url: 'courses/admin/platform/analytics/active-users',
				params: params satisfies Wire<CoursesAdminActiveUsersQueryDto>,
			}),
			providesTags: [TAG],
		}),
	}),
});

export const {
	useGetPlatformAnalyticsQuery,
	useLazyGetPlatformAnalyticsQuery,
	useGetCourseAnalyticsQuery,
	useLazyGetCourseAnalyticsQuery,
	useGetCourseModuleTagBreakdownQuery,
	useLazyGetCourseModuleTagBreakdownQuery,
	useGetActiveUsersQuery,
	useLazyGetActiveUsersQuery,
} = adminAnalyticsEndpoints;
